import { Box } from '@chakra-ui/react';
import List from 'quill/formats/list';
import { useEffect, useState } from 'react';
import ReactQuill, { Quill } from 'react-quill-new';

Quill.register(List, true);

export function QuillInput({
  value,
  onChange,
  placeholder,
}: {
  value: string;
  onChange: ({ value }: { value: string | null }) => void;
  placeholder?: string;
}) {
  const [htmlValue, setHtmlValue] = useState(value ?? '');
  const [isFocusVisible, setFocusVisible] = useState(false);
  const [quill, setQuill] = useState<ReactQuill | null>(null);

  useEffect(() => {
    const re = /^<p>(<br>|<br\/>|<br\s\/>|\s+|)<\/p>$/gm;
    if (re.test(value)) {
      onChange({ value: null });
    }
  }, []);

  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
      ['link'],
      ['clean'],
    ],
  };

  const formats = ['bold', 'italic', 'underline', 'strike', 'list', 'indent', 'link'];

  const handleFocus = () => {
    setFocusVisible(true);
  };

  const handleBlur = () => {
    setFocusVisible(false);
  };

  const handleChange = (value: string) => {
    setHtmlValue(value);
    if (quill?.editor?.getText().trim().length === 0) {
      onChange({ value: null });
    } else {
      onChange({ value });
    }
  };

  return (
    <Box className="text-editor" width={'100%'} css={{ '--focus-ring-width': '2px' }}>
      <ReactQuill
        ref={(el) => setQuill(el)}
        theme="snow"
        value={htmlValue}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        style={
          isFocusVisible
            ? {
                outlineOffset: '0px',
                outlineWidth: '2px',
                outlineColor: 'var(--r3-colors-color-palette-focus-ring)',
                outlineStyle: 'solid',
                borderColor: 'var(--r3-colors-color-palette-focus-ring)',
                borderRadius: 'var(--r3-radii-l2)',
              }
            : {}
        }
      />
    </Box>
  );
}

export default QuillInput;
